/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FreeNightsProgram } from './FreeNightsProgram';
import {
    FreeNightsProgramFromJSON,
    FreeNightsProgramFromJSONTyped,
    FreeNightsProgramToJSON,
    FreeNightsProgramToJSONTyped,
} from './FreeNightsProgram';

/**
 * 
 * @export
 * @interface FreeNights
 */
export interface FreeNights {
    /**
     * 
     * @type {FreeNightsProgram}
     * @memberof FreeNights
     */
    program: FreeNightsProgram;
    /**
     * 
     * @type {number}
     * @memberof FreeNights
     */
    nights: number;
}



/**
 * Check if a given object implements the FreeNights interface.
 */
export function instanceOfFreeNights(value: object): value is FreeNights {
    if (!('program' in value) || value['program'] === undefined) return false;
    if (!('nights' in value) || value['nights'] === undefined) return false;
    return true;
}

export function FreeNightsFromJSON(json: any): FreeNights {
    return FreeNightsFromJSONTyped(json, false);
}

export function FreeNightsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreeNights {
    if (json == null) {
        return json;
    }
    return {
        
        'program': FreeNightsProgramFromJSON(json['program']),
        'nights': json['nights'],
    };
}

export function FreeNightsToJSON(json: any): FreeNights {
    return FreeNightsToJSONTyped(json, false);
}

export function FreeNightsToJSONTyped(value?: FreeNights | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'program': FreeNightsProgramToJSON(value['program']),
        'nights': value['nights'],
    };
}

